<template>
  <!-- 自由入力 -->
  <div class="input-parts-container" :class="{'my-box': speaker === 'my', 'other-box': speaker === 'other'}">
    <div
      class="message"
      :style="{
      'background': speaker==='my' ? color.balloonMy : color.balloonOtr + '!important',
      'color': autoColor(speaker === 'my' ? color.balloonMy : color.balloonOtr),
      'filter': shadowStyle(color.shadowType)}">
      <p class="message-title">{{ messageCreate(message) }}</p>
      <article>
        <!-- TEL -->
        <section v-if="typeColumn == 'TEL'" class="section-1">
          <input
          class="input input-on-tel"
          @input="sliceMaxLength(input, 11)"
          placeholder="内容"
          v-model="input"
          :disabled="isInputAfter || isNowButton()" />
          <button
            class="button is-info send-button"
            @click="submit()">
            <span class="mdi mdi-send"></span>
          </button>
        </section>
        <!-- 学歴 / 職歴 / 資格 -->
        <section v-if="(typeColumn == '学歴・職歴'||typeColumn == '資格')" class="section-2">
          <input class="input input-on-num"
            @input="sliceMaxLength(input, 2)"
            @keydown.69.prevent
            @keydown.107.prevent
            @keydown.109.prevent
            @keydown.110.prevent
            @keydown.187.prevent
            @keydown.189.prevent
            @keydown.190.prevent
            min="0"
            type="number"
            placeholder="2010"
            v-model="numYear"
            :disabled="isInputAfter || isNowButton()"
          />
          <p class="year">年</p>
          <input class="input input-on-num"
            @input="sliceMaxLength(input, 2)"
            @keydown.69.prevent
            @keydown.107.prevent
            @keydown.109.prevent
            @keydown.110.prevent
            @keydown.187.prevent
            @keydown.189.prevent
            @keydown.190.prevent
            min="0"
            type="number"
            placeholder="12"
            v-model="numMonth"
            :disabled="isInputAfter || isNowButton()" />
          <p class="month">月</p>
          <input
          class="input input-on-body"
          placeholder="内容を入力"
          v-model="input"
          :disabled="isInputAfter||isNowButton()"/>
          <button
            class="button is-info send-button"
            @click="submit()"
            :disabled="isInputAfter || isNowButton()">
            <span class="mdi mdi-send"></span>
          </button>
        </section>
        <!-- 生年月日 -->
        <section v-if="typeColumn == '生年月日'" class="section-3">
          <b-datepicker
            locale="ja-JP"
            size="is-small"
            v-model="input"
            :focused-date="defaultBirth"
            :mobile-native="false"
            :append-to-body="true"
            placeholder="生年月日を設定"
            :open-on-focus="true"
            :max-date="new Date()"
            icon="calendar-today"
            :min-date="getBirthMinDate(100)"
            :years-range="[-100, +100]"
            :disabled="isInputAfter || isNowButton()"
          >
          </b-datepicker>
          <button
            class="button is-info"
            @click="submit()"
            :disabled="isInputAfter || isNowButton()">
            <span class="mdi mdi-send -right-8px"></span>
            送信
          </button>
        </section>
        <!-- TEL / 生年月日 / 学歴 / 職歴 以外 -->
        <section v-if="(typeColumn!='TEL' && typeColumn!='生年月日' && typeColumn!='学歴・職歴' && typeColumn!='資格')" class="section-4">
          <template v-if="inputType === 'free'">
            <input
              class="input input-on"
              placeholder="内容"
              v-model="input"
              :disabled="isInputAfter || isNowButton()"/>
          </template>
          <template v-else-if="inputType === 'dateone' || inputType === 'datemulti'">
            <div
              class="datepickers"
              v-for="(d, idx) in dateInfo" :key="idx"
            >
              <div style="height: 56px;">
                <span>開始:</span>
                <b-datepicker
                  v-if="parameter.date_type == 'onlydate'"
                  ref="datetimepicker_start"
                  rounded
                  locale="ja-JP"
                  class="datetimepick"
                  :disabled="isNowButton()"
                  :mobile-native="false"
                  :append-to-body="true"
                  size="is-small"
                  :open-on-focus="true"
                  v-model="dateInfo[idx].start"
                  :min-date="new Date()"
                  @input="changeDateInfo(idx)"
                  placeholder="開始日付"
                  icon="calendar-today">
                  <template #right>
                    <b-button
                      label="選択"
                      type="is-success"
                      outlined
                      @click="$refs.datetimepicker_start[idx].toggle()"/>
                  </template>
                </b-datepicker>
                <!-- <b-timepicker
                  v-else-if="parameter.date_type == 'onlytime'"
                  ref="datetimepicker_start"
                  rounded
                  locale="ja-JP"
                  class="datetimepick"
                  :disabled="isNowButton()"
                  :mobile-native="false"
                  :append-to-body="true"
                  size="is-small"
                  :open-on-focus="true"
                  v-model="dateInfo[idx].start"
                  @input="changeDateInfo(idx)"
                  placeholder="開始時間"
                  icon="calendar-today">
                  <template #right>
                    <b-button
                      label="選択"
                      type="is-success"
                      outlined
                      @click="$refs.datetimepicker_start[idx].toggle()"/>
                  </template>
                </b-timepicker> -->
                <b-datetimepicker
                  v-else
                  ref="datetimepicker_start"
                  rounded
                  locale="ja-JP"
                  class="datetimepick"
                  :disabled="isNowButton()"
                  :mobile-native="false"
                  :append-to-body="true"
                  size="is-small"
                  :open-on-focus="true"
                  v-model="dateInfo[idx].start"
                  :min-date="new Date()"
                  @input="changeDateInfo(idx)"
                  placeholder="開始日時"
                  icon="calendar-today">
                  <template #right>
                    <b-button
                      label="選択"
                      type="is-success"
                      outlined
                      @click="$refs.datetimepicker_start[idx].toggle()"/>
                  </template>
                </b-datetimepicker>
              </div>
              <div style="height: 56px;">
                <span>終了:</span>
                <b-datepicker
                  v-if="parameter.date_type == 'onlydate'"
                  rounded
                  ref="datetimepicker_finish"
                  locale="ja-JP"
                  class="datetimepick"
                  :disabled="keepTime || isNowButton()"
                  :mobile-native="false"
                  :append-to-body="true"
                  size="is-small"
                  :open-on-focus="true"
                  v-model="dateInfo[idx].end"
                  :min-datetime="dateInfo[idx].start"
                  placeholder="終了日付"
                  icon="calendar-today">
                  <template #right>
                    <b-button
                      label="選択"
                      type="is-success"
                      outlined
                      @click="$refs.datetimepicker_finish[idx].toggle()"/>
                  </template>
                </b-datepicker>
                <!-- <b-timepicker
                  v-else-if="parameter.date_type == 'onlytime'"
                  rounded
                  ref="datetimepicker_finish"
                  locale="ja-JP"
                  class="datetimepick"
                  :disabled="keepTime || isNowButton()"
                  :mobile-native="false"
                  :append-to-body="true"
                  size="is-small"
                  :open-on-focus="true"
                  v-model="dateInfo[idx].end"
                  :min-datetime="dateInfo[idx].start"
                  placeholder="終了時間"
                  icon="calendar-today">
                  <template #right>
                    <b-button
                      label="選択"
                      type="is-success"
                      outlined
                      @click="$refs.datetimepicker_finish[idx].toggle()"/>
                  </template>
                </b-timepicker> -->
                <b-datetimepicker
                  v-else
                  rounded
                  ref="datetimepicker_finish"
                  locale="ja-JP"
                  class="datetimepick"
                  :disabled="keepTime || isNowButton()"
                  :mobile-native="false"
                  :append-to-body="true"
                  size="is-small"
                  :open-on-focus="true"
                  v-model="dateInfo[idx].end"
                  :min-datetime="dateInfo[idx].start"
                  placeholder="終了日時"
                  icon="calendar-today">
                  <template #right>
                    <b-button
                      label="選択"
                      type="is-success"
                      outlined
                      @click="$refs.datetimepicker_finish[idx].toggle()"/>
                  </template>
                </b-datetimepicker>
              </div>
              <div class="del-button-wrapper">
                <button
                  class="button is-small del-button"
                  @click="delDate(idx)"
                  v-if="inputType === 'datemulti' && idx > 0"
                  :disabled="isNowButton()"
                >
                  削除
                </button>
              </div>
            </div>
            <button
              @click="addDate()"
              class="button is-small is-fullwidth -bottom-8px"
              v-if="inputType === 'datemulti'"
              :disabled="isNowButton()">
              <span class="mdi mdi-plus -right-8px"></span>追加
            </button>
          </template>
          <template v-if="inputType === 'mail'">
            <span style="width: 100%; font-size: 12px; padding-left: 4px;">※ドメインが選択肢にない場合は、左側に全てご記入ください。</span>
            <input
              class="input"
              style="font-size: 14px; width: calc(50% - 32px);"
              placeholder="メールアドレス"
              v-model="input"
              :disabled="isInputAfter || isNowButton()"/>
            <v-select class="input input-domain"
              v-model="domain"
              placeholder="ドメインを指定しない"
              :options="sortCommonDomains"
              :disabled="isInputAfter || isNowButton()"></v-select>
          </template>
          <template v-if="inputType === 'half'">
            <span style="width: 100%; font-size: 12px; padding-left: 4px;">※半角数値のみ入力できます。</span>
            <input
              class="input input-on"
              placeholder="内容"
              v-model="input"
              :disabled="isInputAfter || isNowButton()"/>
          </template>
          <!-- 入力ボタン -->
          <button
            class="button is-info"
            :class="{'send-button': inputType === 'free' || inputType == 'mail'}"
            @click="submit()"
            :disabled="isInputAfter || isNowButton()">
            <span class="mdi mdi-send" :class="{'-right-8px': inputType != 'free' && inputType != 'mail'}"></span>
            {{inputType === 'free' || inputType == 'mail' ? '' : '送信'}}
          </button>
        </section>
      </article>
    </div>
  </div>
</template>

<script>
import hex2rgb from "@/functions/hex2rgb"
// 外部関数
import {
  autoColor,
  shadowStyle,
  messageCreate,
  isNowButton,
} from "@/functions/balloonFunc"
import moment from 'moment'

export default {
  props: ['message', 'speaker', 'color', 'lastIndex', 'logIndex', 'isBot', 'parameter', 'scenarioInput', 'isInputAfter', 'isDemo', 'roboArguments'],
  computed: {
    typeColumn () {
      if (!this.parameter) return ''
      else if (!this.parameter.colomn_name) return ''
      else return this.parameter.colomn_name
    },
    inputType () {
      if (!this.parameter) return 'free'
      else if (!this.parameter.input_type) return 'free'
      else return this.parameter.input_type
    },
    keepTime () {
      if (!this.parameter) return false
      if (this.inputType != 'dateone' && this.inputType != 'datemulti') return false
      else if (!this.parameter.keep_time_hour && !this.parameter.keep_time_minute) return false
      else return true
    },
    sortCommonDomains () {
      return this.commonDomains.sort()
    }
  },
  created () {
    if (this.parameter.colomn_name == '生年月日') {
      if (!this.parameter['default_birth']) {
        this.defaultBirth = new Date()
      } else {
        this.defaultBirth = new Date(this.parameter['default_birth'])
      }
      this.input = this.defaultBirth
    }
  },
  mounted () {
    this.defaultInput()
  },
  methods: {
    autoColor (c) {
      let color = hex2rgb(c)
      return autoColor(color)
    },
    shadowStyle (t) {
      return shadowStyle(t)
    },
    isNowButton () {
      return isNowButton(this.logIndex, this.lastIndex, this.speaker)
    },
    messageCreate (m) {
      return messageCreate(m, this.roboArguments)
    },
    displayDateStr (type, time) {
      if (!time) return '-'
      return this.dateFormat(type, time)
    },
    dateFormat (type, date) {
      let date_format = ''
      if (type == 'onlydate') {
        date_format = 'YYYY/MM/DD(dd)'
      // } else if (type == 'onlytime') {
      //   date_format = 'HH:mm'
      } else {
        date_format = 'YYYY/MM/DD(dd) HH:mm'
      }
      return moment(date).format(date_format)
    },
    displayBirthDayStr (time) {
      if (!time) return '-'
      return this.birthDayFormat(time)
    },
    birthDayFormat (date) {
      return moment(date).format('YYYY/MM/DD')
    },
    isTELCheck (m) {
      const pattern = new RegExp(	/^\d*$/)
      return pattern.test(m)
    },
    submit () {
      this.inputSubmit(this.input, this.isBot, 0)
    },
    errorDateCheck (dateInfo) {
      // 日付形式の場合
      let errIndex = this.$_.findIndex(
        dateInfo,
        (obj) => {
          return !obj.start || !obj.end
        })
      if (errIndex > -1) {
        alert('日付または時間が入っていない項目があります。')
        return false
      }
      errIndex = this.$_.findIndex(
        dateInfo,
        (obj) => {
          return obj.start > obj.end
        })
      if (errIndex > -1) {
        alert('開始日時が終了日時より先の日時となっている項目があります。')
        return false
      }
      return true
    },
    inputSubmit (m, isBot, btnIndex) {
      if (this.inputType == 'dateone' || this.inputType == 'datemulti') {
        if (this.errorDateCheck(this.dateInfo)) {
          this.$emit(
            'inputSubmit',
            this.dateInfo.map((obj) => {
              return this.displayDateStr(this.parameter.date_type, obj.start) + ' ~ ' + this.displayDateStr(this.parameter.date_type, obj.end)
            }).join('\n'),
            isBot,
            btnIndex
          )
        } else {
          return
        }
      } else if (this.parameter.any_flg && (!m || m == 'Invalid date')) {
        // 任意入力の場合は未入力で次に進むように
        m = '未入力'
        this.$emit('inputSubmit', m, isBot, btnIndex)
      } else if (this.inputType == 'mail'){
        if (this.domain) {
          m += this.domain
        }
        // メールアドレスチェック用の正規表現
        const regexp = /^[A-Za-z0-9]{1}[A-Za-z0-9_.-]*@{1}[A-Za-z0-9_.-]{1,}\.[A-Za-z0-9]{1,}$/

        if (!regexp.test(m)) {
          alert('Eメールアドレスの形式が間違っています。\n内容の修正をお願いいたします。')
          return
        }

        if (!confirm("以下のアドレスでよろしいですか？\n" + m)) return
        this.$emit('inputSubmit', m, isBot, btnIndex)
      } else if (this.inputType == 'half'){
        // 半角数値チェック用の正規表現
        const regexp = /^[0-9]*$/
        if (!regexp.test(m)) {
          alert('半角数値のみ入力できます。\n内容の修正をお願いいたします。')
          return
        }
        this.$emit('inputSubmit', m, isBot, btnIndex)
      } else {
        // メールアドレスチェック用の正規表現
        const regexp = /^[A-Za-z0-9]{1}[A-Za-z0-9_.-]*@{1}[A-Za-z0-9_.-]{1,}\.[A-Za-z0-9]{1,}$/
        // 電話番号チェック用の正規表現
        const tel_regexp = /^0\d{9,10}$/
        if (!m) {
          alert('入力内容が不正もしくは、入力内容がございません。')
        } else if (this.parameter.colomn_name == 'Email' && !regexp.test(m)) {
          alert('Eメールアドレスの形式が間違っています。\n内容の修正をお願いいたします。')
        } else if (this.parameter.colomn_name == 'TEL' && !tel_regexp.test(m)) {
          alert('電話番号の形式が間違っています。\n数値のみハイフンなしでの入力をお願い致します。')
        } else if (this.parameter.colomn_name == '生年月日') {
          this.$emit('inputSubmit', this.displayBirthDayStr(m), isBot, btnIndex)
        } else if (this.parameter.colomn_name == '資格' || this.parameter.colomn_name == '学歴・職歴') {
          const tempMsg = this.numYear + '年' + this.numMonth + '月' + m
          this.$emit('inputSubmit', tempMsg, isBot, btnIndex)
        } else {
          this.$emit('inputSubmit', m, isBot, btnIndex)
        }
      }
    },
    sliceMaxLength (m, num) {
      if (m.length > num) {
        alert(num + '桁以内での入力をお願いいたします。')
        this.input = m.slice(0, num)
      }
    },
    defaultInput () {
      const companyId = localStorage.getItem('_user_c')
      const sessionId = localStorage.getItem('SID_' + companyId)
      if (!this.isNowButton() && !this.isDemo && this.parameter.default_flg) {
        const name = localStorage.getItem('DEFAULT_NM_' + sessionId)
        const email = localStorage.getItem('DEFAULT_EM_' + sessionId)
        const tel = localStorage.getItem('DEFAULT_TL_' + sessionId)
        const furigana = localStorage.getItem('DEFAULT_FR_' + sessionId)
        const address = localStorage.getItem('DEFAULT_AD_' + sessionId)
        const list = [
          {
            typeColumn: '名前',
            strageName: name === '未入力' ? '' : name
          },
          {
            typeColumn: 'Email',
            strageName: email === '未入力' ? '' : email
          },
          {
            typeColumn: 'TEL',
            strageName: tel === '未入力' ? '' : tel
          },
          {
            typeColumn: '名前（ふりがな）',
            strageName: furigana === '未入力' ? '' : furigana
          },
          {
            typeColumn: '住所',
            strageName: address === '未入力' ? '' : address
          },
        ]
        for (const l of list) {
          if (this.typeColumn === l.typeColumn) {
            this.input = l.strageName
          }
        }
      } else if (!this.isNowButton() && this.isDemo && this.parameter.default_flg) {
        const name = localStorage.getItem('DEMO_DEFAULT_NM')
        const email = localStorage.getItem('DEMO_DEFAULT_EM')
        const tel = localStorage.getItem('DEMO_DEFAULT_TL')
        const furigana = localStorage.getItem('DEMO_DEFAULT_FR')
        const address = localStorage.getItem('DEMO_DEFAULT_AD')
        const list = [
          {
            typeColumn: '名前',
            strageName: name === '未入力' ? '' : name
          },
          {
            typeColumn: 'Email',
            strageName: email === '未入力' ? '' : email
          },
          {
            typeColumn: 'TEL',
            strageName: tel === '未入力' ? '' : tel
          },
          {
            typeColumn: '名前（ふりがな）',
            strageName: furigana === '未入力' ? '' : furigana
          },
          {
            typeColumn: '住所',
            strageName: address === '未入力' ? '' : address
          },
        ]
        for (const l of list) {
          if (this.typeColumn === l.typeColumn) {
            this.input = l.strageName
          }
        }
      }
    },
    addDate () {
      this.dateInfo.push(
        {
          start: undefined,
          end: undefined
        }
      )
    },
    delDate (idx) {
      this.dateInfo.splice(idx, 1)
    },
    changeDateInfo (idx) {
      if (this.keepTime) {
        let date = new Date(this.dateInfo[idx].start)
        if (this.parameter.keep_time_hour) date.setHours(date.getHours()+this.parameter.keep_time_hour)
        if (this.parameter.keep_time_minute) date.setMinutes(date.getMinutes()+this.parameter.keep_time_minute)
        this.$set(this.dateInfo[idx], 'end', date)
      }
    },
    getBirthMinDate (past_year) {
      let today = new Date()
      today = moment(today.setFullYear(today.getFullYear() - past_year)).toDate()
      return today
    }
  },
  data () {
    return {
      inputDefault: '入力',
      input: '',
      domain: '',
      numYear: null,
      numMonth: null,
      defaultBirth: null,
      dateInfo: [
        {
          start: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 0, 0, 0),
          end: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), this.parameter.keep_time_hour, this.parameter.keep_time_minute, 0)
        }
      ],
      commonDomains: [
        '@gmail.com',
        '@yahoo.co.jp',
        '@yahoo.ne.jp',
        '@yahoo.com',
        '@ybb.ne.jp',
        '@outlook.jp',
        '@outlook.com',
        '@hotmail.co.jp',
        '@hotmail.com',
        '@live.jp',
        '@docomo.ne.jp',
        '@softbank.ne.jp',
        '@i.softbank.jp',
        '@ezweb.ne.jp',
        '@au.com',
        '@ymobile.ne.jp',
        '@icloud.com',
        '@excite.co.jp',
        '@googlemail.com',
        '@me.com',
        '@mineo.jp',
        '@nifty.com',
      ],
    }
  }
};
</script>

<style lang="scss" scoped>
.input-parts-container {
  .message {
    text-align: left;
    padding: 12px 16px;  /* ①上下のpaddingを少し減らし、左右は維持 */
    width: auto;
    max-width: -webkit-fill-available;
    word-wrap: break-word;
    border-radius: 18px;  /* ②より丸みを持たせる */
    font-size: 95%;  /* ③fontsize up */
    line-height: 1.4;  /* ④読みやすさのために行間を調整 */
    margin-bottom: 8px;  /* ⑤メッセージ間の間隔を追加 */
    white-space: pre-wrap;
    transition: 0.7s;
  }
  .message-title {
    filter: none; font-size: 14px; margin-bottom: 5px; margin-top: 5px; white-space: pre-wrap; text-align: left;
  }
  .my-box {
    display: flex;
    justify-content: flex-end;
    flex-direction: column;
    margin-right: 10px;
  }
  .other-box {
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
    margin-left: 10px;
  }
  .del-button-wrapper {
    text-align: end;
  }
  .del-button {
    font-size: 12px;
  }
  .input-on {
    font-size: 14px;
    width: calc(100% - 40px);
    border-bottom-right-radius: 0;
    border-top-right-radius: 0;
  }
  .input-on-tel {
    font-size: 14px;
    width: calc(100% - 40px);
    border-bottom-right-radius: 0;
    border-top-right-radius: 0;
  }
  .input-on-num {
    font-size: 14px;
    width: 64px;
    margin-bottom: 8px;
  }
  .input-on-body {
    font-size: 14px;
    width: calc(100% - 40px);
    border-bottom-right-radius: 0;
    border-top-right-radius: 0;
    margin-bottom: 8px;
  }
  // Chrome、Safari
  input[type="number"]::-webkit-outer-spin-button,
  input[type="number"]::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  // Firefox、IE
  input[type="number"] {
    -moz-appearance:textfield;
  }
  .input-off {
    font-size: 14px;
    width: 100%;
    border-bottom-right-radius: 0;
    border-top-right-radius: 0;
  }
  .send-button {
    width: 40px;
    border-bottom-left-radius: 0;
    border-top-left-radius: 0;
  }
  article {
    display: flex;
    section {
      width: 100%;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      .datetimepick {
        font-size: 12px;
      }
    }
  }
  button {
    font-size: 14px;
  }
  .section-2 {
    margin-left: 4px;
    margin-right: 4px;
    button {
      margin-bottom: 8px;
    }
    .year {
      margin-left: 4px;
      margin-right: 8px;
    }
    .month {
      margin-left: 4px;
    }
  }
  .section-3 {
    margin-left: 4px;
    margin-right: 4px;
    display: flex;
    align-items: flex-start;
    flex-direction: column;
  }
  .datepickers {
    width: -webkit-fill-available;
    background: #fff;
    padding: 8px;
    border-radius: 6px;
    margin-bottom: 16px;
    box-shadow: 0 0 4px gray;
  }

  .input-domain {
    padding: 0;
    border: none;
    font-size: 14px;
    width: calc(50% - 32px);
    white-space: nowrap;
    /deep/ .vs__dropdown-toggle {
      width: 100%;
      height: 100%;
      border-color: #dbdbdb;
      border-radius: 4px;
      color: #363636;
      box-shadow: inset 0 0.0625em 0.125em rgba(10, 10, 10, 0.05);
    }
    /deep/ .vs__dropdown-toggle:hover {
      border-color: #b5b5b5;
    }
    /deep/ .vs__dropdown-toggle:focus-within {
      border-color: #EE2C98;
      -webkit-box-shadow: 0 0 0 0.125em rgba(238, 44, 152, 0.25);
      box-shadow: 0 0 0 0.125em rgba(238, 44, 152, 0.25);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/BalloonParts/InputParts.vue